import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=1960233b&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=1960233b&prod&lang=scss&"
import style1 from "./Home.vue?vue&type=style&index=1&id=1960233b&prod&lang=scss&scoped=true&"
import style2 from "./Home.vue?vue&type=style&index=2&id=1960233b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960233b",
  null
  
)

export default component.exports